import gql from 'graphql-tag';

export const EDIT_USER = gql`
  mutation EditUser($input: EditUserInput!) {
    editUser(input: $input) {
      success
      error
      user {
        id
        ERAUID
        firstName
        lastName
        email
        DOB
        Gender
        disciplineId
        phone
        street
        street2
        city
        state
        zip
        country
        socialTags
        photoFileName
        LegalFirstName
        LegalLastName
        nickname
        hometown
        careerEarnings
        worldChampionshipEarned
        height
        weight
        facebook
        instagram
        twitter
        isParent
        isAthlete
        USCitizen
        TaxInfoUpdateDate
      }
    }
  }
`;
